<template>
    <div>
        <el-tabs :tab-position="'top'" type="" style="margin-top: 5px">
            <el-tab-pane :label="$t('getapi[67]')">
                <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
                    <el-col :span="12">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurl"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChange"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :file-list="fileList"
                                :limit="1"
                        >
                            <el-button slot="trigger" size="small" type="primary" :disabled="!btn.Manhour">{{$t('getapi[6422]')}}
                            </el-button>
                            <div slot="tip" class="el-upload__tip">{{$t('getapi[6484]')}}</div>
                        </el-upload>
                    </el-col>
                    <el-col :span="12" align="right">
                        <el-button @click="updateworkhour" size="small" type="success">{{$t('getapi[8006]')}}</el-button>&nbsp;&nbsp;
                        <span class="label-fade-enter">{{$t('getapi[506]')}}</span>
                        <el-select filterable v-model="drosele" size="small">
                            <el-option v-for="item in drolist" :label="item.TypeName" :value="item.TypeId"
                                       :key="item.TypeId"></el-option>
                        </el-select>
                        <el-button @click="okbtn" size="small" type="success" :loading="loading"
                                   :disabled="!btn.Manhour" style="margin-left:5px">{{$t('getapi[370]')}}
                        </el-button>
                    </el-col>
                </el-row>
                <vxe-table :data="datajson" size="mini" :loading="loading" :height="tableHeight" stripe border
                           resizable
                           :header-cell-style="$limits.headerClass"
                           ref="singleTable">
                    <vxe-table-column type="seq" :title="$t('getapi[1297]')" width="60"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Exclusively_ID" label="ID" v-if="false"
                                      width="150px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[137]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="item_name" :title="$t('getapi[546]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="routing_version" :title="$t('getapi[547]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="routing_sequence" :title="$t('getapi[573]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="workproc_name" :title="$t('getapi[574]')"
                                      width="100px">
                        <template slot-scope="scope">
                            <el-input
                                    v-model="scope.row.workproc_name"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:100%"
                                    :disabled="drosele != 11"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showrout(scope)"></i>
                            </el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="workcenter_code" :title="$t('getapi[584]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="drosele == 8 ? 'check' : ''" field="workcenter_name"
                                      :title="$t('getapi[585]')" width="100px">
                        <template slot-scope="scope">
                            <el-input
                                    v-model="scope.row.workcenter_name"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:100%"
                                    :disabled="drosele != 8"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showwcenter(scope)"></i>
                            </el-input>
                        </template>
                    </vxe-table-column>


                    <!-- <vxe-table-column show-footer-overflow field="workcenter_name" :title="$t('getapi[585]')"
                                      width="100px"></vxe-table-column> -->
                    <vxe-table-column show-footer-overflow :disabled="drosele != 10" field="workproc_description" :title="$t('getapi[575]')"
                                      width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.workproc_description" type="text" @mousewheel.native.prevent
                                       :disabled="drosele != 10"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="version_status" :title="$t('getapi[552]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="drosele == 1 ? 'check' : ''"
                                      field="ready_manhour" :title="$t('getapi[577]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.ready_manhour" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      step="0.01" :disabled="drosele != 1"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="drosele == 1 ? 'check' : ''"
                                      field="running_manhour" :title="$t('getapi[578]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.running_manhour" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      step="0.01" :disabled="drosele != 1"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="drosele == 1 ? 'check' : ''"
                                      field="queue_manhour" :title="$t('getapi[579]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.queue_manhour" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      step="0.01" :disabled="drosele != 1"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="measure_unit_name" :title="$t('getapi[580]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="drosele == 1 ? 'check' : ''" field="std_manhour"
                                      :title="$t('getapi[581]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.std_manhour" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      step="0.01" :disabled="drosele != 1"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="report_measure_method" :title="$t('getapi[582]')"
                                      width="100px"></vxe-table-column>

                    
                    <vxe-table-column :class-name="drosele == 1 ? 'check' : ''" field="man_power"
                                      :title="$t('getapi[586]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.man_power" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.01"
                                      :disabled="drosele != 1"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="parallel_flag" :title="$t('getapi[587]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="key_flag" :title="$t('getapi[588]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="drosele == 2 ? 'check' : ''" field="area"
                                      :title="$t('getapi[139]') + 'd㎡'" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.area" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.01"
                                      :disabled="drosele != 2"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="drosele == 5 ? 'check' : ''" field="edit_routing_leadtime"
                                      :title="$t('getapi[8279]')" width="120px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.edit_routing_leadtime" type="number" autocomplete="off" title="" @mousewheel.native.prevent step="0.01"
                                      :disabled="drosele != 5"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="drosele == 3 ? 'check' : ''"
                                      field="move_direction" :title="$t('getapi[554]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.move_direction" type="text"
                                      :disabled="drosele != 3"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="direct_stuff_move_flag" :title="$t('getapi[553]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="drosele == 6 ? 'check' : ''" field="group_name"
                                      :title="$t('getapi[12444]')" width="100px">
                        <template slot-scope="scope">
                            <el-input
                                    v-model="scope.row.group_name"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:100%"
                                    :disabled="drosele != 6"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectGroupName(scope)"></i>
                            </el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="drosele == 7 ? 'check' : ''" field="r_code"
                                      :title="$t('getapi[12445]')" width="100px">
                        <template slot-scope="scope">
                            <el-input
                                    v-model="scope.row.r_code"
                                    type="text"
                                    readonly
                                    size="mini"
                                    style="width:100%"
                                    :disabled="drosele != 7"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRCode(scope)"></i>
                            </el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="drosele == 4 ? 'check' : ''" field="remark"
                                      :title="$t('getapi[143]')" width="200px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" type="text" :disabled="drosele != 4"></el-input>
                        </template>
                    </vxe-table-column>
                    <!-- <vxe-table-column :title="$t('basic.edit')" fixed="right" width="200">
                        <template #default>
                            <vxe-button type="text">{{ $t('getapi[637]') }}</vxe-button>
                        </template>
                    </vxe-table-column> -->
                    <vxe-table-column fixed="right" :title="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[40]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="delline(scope)"
                            >
                                <el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </vxe-table-column>
                </vxe-table>

            </el-tab-pane>
            <!-- 工艺备注 -->
            <!-- <el-tab-pane :label="$t('getapi[6001]')">
            <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
            <el-col :span="12">
            <el-upload
            class="upload-demo"
            ref="upload"
            :action="uploadurlremark"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-change="handleChangeremark"
            :on-success="handleSuccessremark"
            :on-error="handleErrorremark"
            :file-list="fileList"
            :limit="1"
            >
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传.xlxs文件</div>
            </el-upload>
            </el-col>
            <el-col :span="12" align="right"><el-button @click="okbtns" size="small" type="success" :loading="loading" :disabled="loading">确认导入</el-button></el-col>
            </el-row>
            <vxe-table size="mini" :loading="loading" :height="tableHeight - 30" :data="datajsonremark" stripe border resizable>
            <vxe-table-column show-footer-overflow field="Exclusively_ID" label="ID" v-if="false"></vxe-table-column>
            <vxe-table-column width="380" show-footer-overflow field="part_code" :title="$t('getapi[112]')"></vxe-table-column>
            <vxe-table-column width="180" show-footer-overflow field="part_version" :title="$t('getapi[149]')"></vxe-table-column>
            <vxe-table-column width="180" show-footer-overflow field="routing_version" :title="$t('getapi[547]')"></vxe-table-column>
            <vxe-table-column  show-footer-overflow field="remark" :title="$t('getapi[143]')"   width="800">
            <template slot-scope="scope"> class-name="check"
            <el-input v-model="scope.row.remark" type="text"></el-input>
            </template>
            </vxe-table-column>
            <vxe-table-column show-footer-overflow fixed="right" :title="$t('basic.edit')" width="100">
            <template slot-scope="scope">
            <el-popconfirm
            :confirmButtonText="$t('getapi[937]')"
            :cancelButtonText="$t('getapi[6]')"
            icon="el-icon-info"
            iconColor="red"
            :title="$t('getapi[637]')"
            @onConfirm="dellines(scope)"
            >
            <el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
            </el-popconfirm>
            </template>
            </vxe-table-column>
            </vxe-table>
            </el-tab-pane> -->

            <el-tab-pane :label="$t('getapi[6002]')"><!-- 流转方向 -->
                <el-row style=" margin: 0px auto 5px;background: white;padding: 10px 20px 5px;">
                    <el-col :span="12">
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurlliu"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChangeliu"
                                :on-success="handleSuccessliu"
                                :on-error="handleError"
                                :file-list="fileList"
                                :limit="1"
                        >
                            <el-button slot="trigger" size="small" type="primary" :disabled="!btn.Notes">{{$t('getapi[6422]')}}
                            </el-button>
                            <div slot="tip" class="el-upload__tip">{{$t('getapi[6484]')}}</div>
                        </el-upload>
                    </el-col>
                    <el-col :span="12" align="right">

                        <span class="label-fade-enter">{{$t('getapi[506]')}}</span>
                        <el-select filterable v-model="droseleliu" size="small">
                            <el-option v-for="item in drolistliu" :label="item.TypeName" :value="item.TypeId"
                                       :key="item.TypeId"></el-option>
                        </el-select>
                        <el-button @click="okbtnliu" size="small" type="success" :loading="loading"
                                   :disabled="!btn.Notes">{{$t('getapi[370]')}}
                        </el-button>
                    </el-col>
                </el-row>
                <!-- 表格 -->
                <vxe-table :data="datajsonliu" size="mini" :loading="loading" :height="tableHeight" stripe border
                           resizable
                           :header-cell-style="$limits.headerClass">
                    <!-- <vxe-table-column show-footer-overflow field="Exclusively_ID" label="ID" v-if="false" width="100px"></vxe-table-column> -->
                    <vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[137]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="item_name" :title="$t('getapi[546]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_name" :title="$t('getapi[116]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="routing_version" :title="$t('getapi[547]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="effect_date" :title="$t('getapi[548]')"
                                      width="120"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="invalid_date" :title="$t('getapi[549]')"
                                      width="100px"></vxe-table-column>

                    <vxe-table-column show-footer-overflow field="audit_person" :title="$t('getapi[550]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="audit_time" :title="$t('getapi[732]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="version_status" :title="$t('getapi[552]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="create_person" :title="$t('getapi[410]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="create_time" :title="$t('getapi[135]')"
                                      width="100px"></vxe-table-column>

                    <vxe-table-column show-footer-overflow field="enable_flag" :title="$t('getapi[555]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="freeze_reason" :title="$t('getapi[556]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="droseleliu == 3 ? 'check' : ''"
                                      field="move_direction" :title="$t('getapi[554]')" width="100px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.move_direction" type="text"
                                      :disabled="droseleliu != 3"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column field="direct_stuff_move_flag" :title="$t('getapi[553]')"
                                      width="100px"></vxe-table-column>
                    <vxe-table-column :class-name="droseleliu == 9 ? 'check' : ''" show-footer-overflow field="tool"
                                      :title="$t('getapi[12645]')" width="200px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.tool" type="text" :disabled="droseleliu != 9"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column :class-name="droseleliu == 4 ? 'check' : ''" field="remark"
                                      :title="$t('getapi[143]')" width="200px">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark" type="text" :disabled="droseleliu != 4"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="modify_person" width="100px"
                                      :title="$t('getapi[733]')"></vxe-table-column>
                    <vxe-table-column show-overflow-tooltip field="modify_time" width="100px"
                                      :title="$t('getapi[1210]')"></vxe-table-column>


                    <vxe-table-column fixed="right" :title="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[937]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="dellineliu(scope)"
                            >
                                <el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </el-tab-pane>
        </el-tabs>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetGroupNamePopupList'" @callback="getGroupName" ref="groupname"></selector>
        <selector :isVisible="wcentervisible" :isSplitPage="false" :postUrl="'Basic/Items/GetEngWorkCenterPopupList'"
                  @callback="getwcenter" ref="rout"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetApsResourcePopupList'" @callback="getRCode" ref="rcode"></selector>
        <selector :isVisible="false" :isSplitPage="true" :postUrl="'Basic/Items/GetRoutingTypePopupList'"
                  @callback="getrout" ref="routs"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: 'carftexp',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight- 220
            },
        },
        data() {
            return {
                fileList: [],
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                datajsonremark: [],
                datajsonliu: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                uploadurlremark: '',
                uploadurlliu: '',
                drolist: [],
                drolistliu: [],
                drosele: 0,
                droseleliu: 0,
                total1: 0,
                btn: {
                    //工时
                    Manhour: false,
                    //备注
                    Notes: false,
                },
                rowindex: -1,
                wcentervisible: false,
                wcrowindex: -1,
                scrollTop:0,
                scrollTop1:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            let LanType=0;
            let language='';			
            language=window.localStorage.getItem('lang');
            if(language=='zh'){
                LanType=1;
            }else if(language=='en'){
                LanType=2;
            }else if(language=='hu'){
                LanType=3;
            }

            that.uploadurl = Common.Url + 'Eng/Routings/RWHoursUpFile?Type='+LanType+'&token=' + token;
            that.uploadurlremark = Common.Url + 'Eng/Routings/RoutRemarkUpFile?token=' + token;
            that.uploadurlliu = Common.Url + 'Eng/Routings/RoutMoveUpFile?token=' + token;
            this.getDropList();
            this.getDropLists();
            this.btnauthority();
        },
        mounted() {
            console.log('mounted');
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
                //工时
                that.btn.Manhour = false;
                //备注
                that.btn.Notes = false;

                if (that.$limits.authority('plv3', 38, 1) > 0) {
                    //工时
                    that.btn.Manhour = true;

                }
                if (that.$limits.authority('plv2', 392, 1) > 0) {
                    //备注
                    that.btn.Notes = true;
                }
            },
            //删除行
            delline(e) {
                console.log(e);
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajson.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            dellines(e) {
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajsonremark.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            dellineliu(e) {
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajsonliu.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                console.log(that.selectIDData);
            },
            //工艺工时更新字段下拉框
            getDropList() {
                let that = this;
                that.$http.urlpost('Eng/Routings/RWHoursDropList', {}, res => {
                    console.log(res);
                    if (res.Success == 1) {
                        that.drolist = res.DataContent;
                        that.total1 = res.DataContent.length;
                    }
                });
            },
            //流转下拉
            getDropLists() {
                let that = this;
                that.$http.urlpost('Eng/Routings/RoutMoveDropList', {}, res => {
                    console.log(res);
                    if (res.Success == 1) {
                        that.drolistliu = res.DataContent;
                    }
                });
            },
            updateworkhour() {
                let that = this;
                that.$http.urlpost('/Eng/Routings/UpdateManHour', {}, res => {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[8628]'));//'更新完成！'
                    }
                });
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        that.datajson = file.response.DataContent;
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajson = res.DataContent;
                }
                that.fileList = [];
                that.$refs.upload.clearFiles();
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleChangeremark(file, fileList) {
                let that = this;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        that.datajsonremark = file.response.DataContent;
                    }
                }
            },
            handleSuccessremark(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajsonremark = res.DataContent;
                }
                that.$refs.upload.clearFiles();
            },
            handleErrorremark(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleChangeliu(file, fileList) {
                let that = this;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        that.datajsonliu = file.response.DataContent;
                    }
                    that.$refs.upload.clearFiles();
                }
            },
            handleSuccessliu(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajsonliu = res.DataContent;
                }
                that.fileList = [];

            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview" + file);
            },
            // 保存数据
            okbtn() {
                let that = this;
                that.loading = true;
                let parm = {
                    SaveType: that.drosele,
                    LangType: that.$processdata.getLang(),
                    List: []
                };
                parm.List = that.datajson;
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/Routings/RWHoursSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[818]'));
                    }
                    that.loading = false;
                });
            },
            // 保存备注数据
            okbtns() {
                let that = this;
                that.loading = true;
                let parm = that.datajsonremark;
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[818]'));
                    }
                    that.loading = false;
                });
            },
            // 保存流转方向数据
            okbtnliu() {
                let that = this;
                if (that.droseleliu == 4) {
                    that.loading = true;
                    let parm = that.datajsonliu;
                    console.log(JSON.stringify(parm));
                    that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[818]'));
                        }
                        that.loading = false;
                    });
                } else if (that.droseleliu == 3) {
                    that.loading = true;
                    let parm = {
                        SaveType: that.droseleliu,
                        List: []
                    };
                    parm.List = that.datajsonliu;
                    console.log(JSON.stringify(parm));
                    that.$http.urlpost('Eng/Routings/RoutMoveSave', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[818]'));
                        }
                        that.loading = false;
                    });
                } else if(that.droseleliu == 9){
                    that.loading = true;
                    let parm = that.datajsonliu;
                    console.log(JSON.stringify(parm));
                    that.$http.urlpost('/Eng/Routings/RoutToolSave', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[818]'));
                        }
                        that.loading = false;
                    });
                } else{

                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                }
            },
            selectGroupName(row){
                let that = this;
                console.log(row)
                that.rowindex = row.$rowIndex
                that.$refs.groupname.clearInput(true);
            },
            getGroupName(val){
                let that = this;
                that.datajson[this.rowindex].r_code = ''
                that.datajson[this.rowindex].group_name = val.group_name
            },
            selectRCode(row){
                let that = this;
                that.rowindex = row.$rowIndex
                that.$refs.rcode.clearInput(true);
            },
            getRCode(val){
                let that = this;
                console.log(val)
                that.datajson[this.rowindex].group_name = val.group_name
                that.datajson[this.rowindex].r_code = val.r_code
            },
            
            //工作中心弹框
            showwcenter(row) {
                let that = this;
                console.log("测试1:"+row.$rowIndex)
                that.wcrowindex = row.$rowIndex;
                that.wcentervisible = true;
                that.$refs.rout.clearInput(that.wcentervisible);
            },
            //获取工作中心信息
            getwcenter(val) {
                let that = this;
                console.log("测试:"+that.wcrowindex)
                that.datajson[that.wcrowindex].workcenter_code = val.workcenter_code;
                that.datajson[that.wcrowindex].workcenter_name = val.workcenter_name;
            },
            //工序弹框
            showrout(row) {
                let that = this;
                this.rowindex = row.$rowIndex;
                this.$refs.routs.clearInput(true);
                //this.addline(row.$index);
            },
            //获取工序信息
            getrout(val) {
                let that = this
                that.datajson[that.rowindex].workproc_id = val.exclusively_id;
                that.datajson[that.rowindex].workproc_code = val.workproc_code;
                that.datajson[that.rowindex].workproc_name = val.workproc_name;
            },
        }
    };
</script>

<style lang="scss" scoped>
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
</style>
